import * as Sentry from '@sentry/react';
import axios from 'axios';

// ----------------------------------------------------------------------

const client = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Ocp-Apim-Subscription-Key': import.meta.env.VITE_AZURE_SUBSCRIPTION_KEY,
  },
});

// CSP checking interceptor
client.interceptors.response.use(
  (response) => {
    const cspHeader = response.headers['content-security-policy'];

    if (!cspHeader || !cspHeader.includes("default-src 'self'")) {
      console.warn('Suspicious CSP header detected:', cspHeader);
      //** Removing for now as it is causing a lot of noise - Will implement again at a later date */
      // Sentry.captureEvent({
      //   message: 'Suspicious CSP header detected',
      //   level: 'warning',
      //   extra: { cspHeader, url: response.config.url },
      // });
    }

    return response;
  },
  (error) => {
    Sentry.captureException(new Error(`Axios Interceptor Error: ${error}`));
    return Promise.reject(error);
  },
);

const headersMap = {
  PUT: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  POST: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  GET: {
    Accept: 'application/json',
  },
  DELETE: {
    Accept: 'application/json',
  },
  PATCH: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  HEAD: {
    Accept: 'application/json',
  },
};

export const pdf = async ({ accessToken, path, headers }) => {
  try {
    const response = await client.get(path, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
        Authorization: `Bearer ${accessToken}`,
        ...headers,
      },
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    return url;
  } catch (error) {
    Sentry.captureException(new Error(`PDF Fetch Error: ${error}`));
    return Promise.reject(error);
  }
};

export const request = async ({ method, accessToken, oktaAccessToken, ...options }) => {
  const headers = {};

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  if (oktaAccessToken) {
    headers.Authorization = `Bearer ${oktaAccessToken}`;
  }

  if (headersMap[method]) {
    Object.assign(headers, headersMap[method]);
  }

  const onSuccess = (response) => response;
  const onError = (error) => {
    // Catch errors and add additional logging here
    return error;
  };

  try {
    const response = await client({
      ...options,
      method,
      headers: {
        ...options.headers,
        ...headers,
      },
    });

    Sentry.captureMessage('info', {
      contexts: {
        responseDetails: {
          url: response.config.url,
          status: response.status,
          headers: response.headers,
        },
      },
    });

    return onSuccess(response);
  } catch (error) {
    Sentry.captureException(new Error(`Axios Request Error: ${error}`));
    // throw error;
    return onError(error);
  }
};
